(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ss-image-fit"] && !Shopify.designMode) return;
  try {
    (() => {
  const normalize = image => {
    if (!image.complete || !image.naturalWidth || image.dataset.ssFramed) return;
    image.dataset.ssFramed = 'true';
    try {
      const canvas = document.createElement('canvas');
      canvas.width = canvas.height = 96;
      const context = canvas.getContext('2d', { willReadFrequently: true });
      if (!context) return;
      context.fillStyle = '#fff';
      context.fillRect(0, 0, 96, 96);
      const ratio = Math.min(96 / image.naturalWidth, 96 / image.naturalHeight);
      const width = image.naturalWidth * ratio;
      const height = image.naturalHeight * ratio;
      context.drawImage(image, (96-width)/2, (96-height)/2, width, height);
      const pixels = context.getImageData(0,0,96,96).data;
      const samples = [[2,2],[48,2],[93,2],[2,48],[93,48],[2,93],[48,93],[93,93]];
      const colors = [0,1,2].map(channel => samples.map(([x,y])=>pixels[(y*96+x)*4+channel]).sort((a,b)=>a-b)[4]);
      if(Math.min(...colors)<185) return;
      const distance = offset => Math.max(...colors.map((color,channel)=>Math.abs(color-pixels[offset+channel])));
      let plain=0;
      for(let x=2;x<94;x++) {
        if(distance((2*96+x)*4)<28) plain++;
        if(distance((93*96+x)*4)<28) plain++;
        if(distance((x*96+2)*4)<28) plain++;
        if(distance((x*96+93)*4)<28) plain++;
      }
      if(plain<320) return;
      let left=96,top=96,right=0,bottom=0,count=0;
      for (let y=2;y<94;y++) for(let x=2;x<94;x++) {
        const offset=(y*96+x)*4;
        if (distance(offset) > 30) {
          left=Math.min(left,x);right=Math.max(right,x);
          top=Math.min(top,y);bottom=Math.max(bottom,y);count++;
        }
      }
      if(count<150 || right-left<15 || bottom-top<15) return;
      left=Math.max(0,left-4);right=Math.min(95,right+4);
      top=Math.max(0,top-4);bottom=Math.min(95,bottom+4);
      const scale=Math.min(2.2,Math.max(.72,78/Math.max(right-left,bottom-top)));
      const dx=(47.5-(left+right)/2)*scale/96*100;
      const dy=(47.5-(top+bottom)/2)*scale/96*100;
      image.style.setProperty('--ss-image-transform','translate('+dx.toFixed(2)+'%,'+dy.toFixed(2)+'%) scale('+scale.toFixed(3)+')');
      image.dataset.ssFramed = 'normalized';
    } catch (_) {}
  };
  const scan = root => {
    root.querySelectorAll('.ss-grid-card .first-image, .photo-image .ss-product-image').forEach(image => {
      if(image.complete) normalize(image);
      else image.addEventListener('load',()=>normalize(image),{once:true});
    });
  };
  const start=()=>scan(document);
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',start,{once:true});
  else start();
  document.addEventListener('shopify:section:load',event=>scan(event.target));
  const observer=new MutationObserver(records=>{
    for(const record of records) for(const node of record.addedNodes) {
      if(node.nodeType===1 && node.querySelectorAll) scan(node);
    }
  });
  observer.observe(document.body,{childList:true,subtree:true});
})();
  } catch(e) { console.error(e); }
})();

})();
